var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 225,
    height: 43,
    viewBox: "0 0 720 132",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.943
    },
    fill: "#2bc97c",
    d: "M 65.5,-0.5 C 69.1667,-0.5 72.8333,-0.5 76.5,-0.5C 76.5,3.16667 76.5,6.83333 76.5,10.5C 55.2584,11.5765 41.4251,22.2431 35,42.5C 30.9411,65.5504 39.4411,82.0504 60.5,92C 65.3504,93.7315 70.3504,94.7315 75.5,95C 76.4601,98.73 76.7935,102.563 76.5,106.5C 48.24,105.122 30.4066,90.7887 23,63.5C 19.5144,30.1952 33.6811,8.86183 65.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.931
    },
    fill: "#2bc97c",
    d: "M 68.5,20.5 C 92.4536,18.792 105.787,29.792 108.5,53.5C 104.5,53.5 100.5,53.5 96.5,53.5C 95.7481,40.5792 88.9147,33.2459 76,31.5C 59.0454,34.7383 52.7121,44.7383 57,61.5C 61.0764,69.4049 67.5764,73.4049 76.5,73.5C 76.5,77.5 76.5,81.5 76.5,85.5C 52.6457,82.807 41.8124,69.4737 44,45.5C 47.6829,32.6514 55.8496,24.3181 68.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.956
    },
    fill: "#000000",
    d: "M 331.5,43.5 C 338.167,43.5 344.833,43.5 351.5,43.5C 351.5,71.5 351.5,99.5 351.5,127.5C 344.833,127.5 338.167,127.5 331.5,127.5C 331.5,99.5 331.5,71.5 331.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.932
    },
    fill: "#000000",
    d: "M 368.5,43.5 C 375.167,43.5 381.833,43.5 388.5,43.5C 388.5,48.8333 388.5,54.1667 388.5,59.5C 381.833,59.5 375.167,59.5 368.5,59.5C 368.5,54.1667 368.5,48.8333 368.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.938
    },
    fill: "#2bc97c",
    d: "M 0.5,52.5 C 4.5,52.5 8.5,52.5 12.5,52.5C 14.4766,85.6318 31.4766,106.465 63.5,115C 67.7901,115.923 72.1234,116.423 76.5,116.5C 76.5,120.167 76.5,123.833 76.5,127.5C 36.8668,125.927 12.0334,105.927 2,67.5C 1.08776,62.5364 0.587759,57.5364 0.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.952
    },
    fill: "#000000",
    d: "M 122.5,65.5 C 131.949,64.8075 139.116,68.4742 144,76.5C 149.825,67.7737 157.992,64.2737 168.5,66C 178.665,68.5016 184.165,75.0016 185,85.5C 185.5,99.496 185.667,113.496 185.5,127.5C 178.833,127.5 172.167,127.5 165.5,127.5C 165.667,114.829 165.5,102.162 165,89.5C 163.538,81.4708 159.038,79.3042 151.5,83C 149.959,84.5793 148.792,86.4127 148,88.5C 146.599,101.448 146.099,114.448 146.5,127.5C 139.833,127.5 133.167,127.5 126.5,127.5C 126.667,114.829 126.5,102.162 126,89.5C 124.857,81.6261 120.69,79.2928 113.5,82.5C 111.501,84.4935 110.001,86.8268 109,89.5C 107.626,102.12 107.126,114.787 107.5,127.5C 100.833,127.5 94.1667,127.5 87.5,127.5C 87.5,107.167 87.5,86.8333 87.5,66.5C 94.1667,66.5 100.833,66.5 107.5,66.5C 107.336,69.1873 107.503,71.854 108,74.5C 111.752,69.551 116.585,66.551 122.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.937
    },
    fill: "#000000",
    d: "M 314.5,65.5 C 318.315,64.9185 321.649,65.7518 324.5,68C 324.511,73.0246 324.345,78.1913 324,83.5C 322.927,84.2797 321.76,84.113 320.5,83C 309.309,79.6749 302.142,83.5082 299,94.5C 298.5,105.495 298.333,116.495 298.5,127.5C 291.833,127.5 285.167,127.5 278.5,127.5C 278.5,107.167 278.5,86.8333 278.5,66.5C 285.167,66.5 291.833,66.5 298.5,66.5C 298.336,69.1873 298.503,71.854 299,74.5C 303.141,69.4828 308.308,66.4828 314.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.938
    },
    fill: "#000000",
    d: "M 426.5,65.5 C 459.141,64.3053 471.975,79.6386 465,111.5C 458.669,124.172 448.336,130.172 434,129.5C 412.814,129.145 401.648,118.478 400.5,97.5C 400.737,79.9341 409.403,69.2675 426.5,65.5 Z M 429.5,80.5 C 441.357,79.69 447.024,85.3567 446.5,97.5C 446.873,104.586 444.206,110.086 438.5,114C 429.915,116.126 424.415,112.959 422,104.5C 420.919,97.9456 421.586,91.6123 424,85.5C 425.73,83.5981 427.563,81.9314 429.5,80.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.931
    },
    fill: "#000000",
    d: "M 200.5,66.5 C 207.167,66.5 213.833,66.5 220.5,66.5C 220.089,80.8839 220.589,95.2172 222,109.5C 226.078,113.813 230.912,114.646 236.5,112C 238.652,109.531 240.152,106.698 241,103.5C 241.5,91.1712 241.667,78.8378 241.5,66.5C 248.422,66.1878 255.256,66.5212 262,67.5C 262.175,88.551 262.342,108.551 262.5,127.5C 255.5,127.5 248.5,127.5 241.5,127.5C 241.663,125.143 241.497,122.81 241,120.5C 232.329,129.302 222.162,131.468 210.5,127C 204.737,123.09 201.57,117.59 201,110.5C 200.5,95.8371 200.333,81.1705 200.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.95
    },
    fill: "#000000",
    d: "M 368.5,66.5 C 375.167,66.5 381.833,66.5 388.5,66.5C 388.5,86.8333 388.5,107.167 388.5,127.5C 381.833,127.5 375.167,127.5 368.5,127.5C 368.5,107.167 368.5,86.8333 368.5,66.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0901db59a31f88319bb71689939b5603.svg";
export { ForwardRef as ReactComponent };